import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TreePermission } from '../../definitions/tiers.interface';

@Component({
  selector: 'app-create-permission-dialog',
  templateUrl: './create-permission-dialog.component.html',
  styleUrls: ['./create-permission-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreatePermissionDialogComponent {
  inputValue = '';

  constructor(
    public _dialogRef: MatDialogRef<CreatePermissionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { isPermissionChild: boolean; permission?: TreePermission }
  ) {}

  create() {
    this._dialogRef.close({ action: 'create', value: this.inputValue });
  }

  close() {
    this._dialogRef.close();
  }
}
